import createSvgIcon from '@icons/utils/create-svg-icon';
import CheckSvg from './svg/check.svg';

const CheckIcon = createSvgIcon(CheckSvg);

export default CheckIcon;
